import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

class ModalFormVehicleManagement extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    if (props.vehicle) {
      this.state = {
        vehicleKey: props.vehicle.$key,
        vehicle: {
          plate: props.vehicle.plate || '',
          fleet: props.vehicle.fleet || '',
          brand: props.vehicle.brand || '',
          model: props.vehicle.model || '',
          chassis: props.vehicle.chassis || '',
          manufYear: props.vehicle.manufYear || '',
          modelYear: props.vehicle.modelYear || '',
        },
      };
    }

    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalAccept = this.handleModalAccept.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal && !this.props.showModal) {
      this.setState({
        vehicleKey: nextProps.vehicle.$key || '',
        vehicle: {
          plate: nextProps.vehicle.plate || '',
          fleet: nextProps.vehicle.fleet || '',
          brand: nextProps.vehicle.brand || '',
          model: nextProps.vehicle.model || '',
          chassis: nextProps.vehicle.chassis || '',
          manufYear: nextProps.vehicle.manufYear || '',
          modelYear: nextProps.vehicle.modelYear || '',
        },
      });
    }
  }

  getActionName() {
    return (this.props.vehicle && this.props.vehicle.plate)
      ? 'edit'
      : 'create';
  }

  handleModalClose() {
    this.props.onCancel(this.state.vehicle);
  }

  handleModalAccept(ev) {
    ev.preventDefault();

    this.props.onAccept(this.state.vehicle, this.state.vehicleKey);
    this.setState({ vehicleKey: '', vehicle: {} });
  }

  handleInputChange(ev) {
    const { name, value } = ev.target;

    this.setState({
      vehicle: {
        ...this.state.vehicle,
        [name]: value,
      },
    });
  }

  render() {
    return (
      <Modal show={this.props.showModal} onHide={this.handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{this.getActionName() === 'create' ? 'Criando' : 'Editando'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Veículo</h3>

          <form onSubmit={this.handleModalAccept}>
            <div className="form-group">
              <label htmlFor="plate">Placa</label>
              <input
                type="text"
                className="form-control"
                name="plate"
                value={this.state.vehicle.plate}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="fleet">Frota</label>
              <select
                className="form-control"
                name="fleet"
                value={this.state.vehicle.fleet}
                onChange={this.handleInputChange}
              >
                {_.map(this.props.fleets, (fleet, key) => (
                  <option key={key} value={key}>{fleet.name}</option>
                ))}
                <option value="">Nenhuma</option>
              </select>
              {/* aria-describedby="fleetHelp"
              {/* <small id="fleetHelp" className="form-text text-muted">
              A operação selecionad</small> */}
            </div>

            <div className="form-group">
              <label htmlFor="brand">Marca</label>
              <input
                type="text"
                className="form-control"
                name="brand"
                value={this.state.vehicle.brand}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="model">Modelo</label>
              <input
                type="text"
                className="form-control"
                name="model"
                value={this.state.vehicle.model}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="chassis">Chassi Final</label>
              <input
                type="text"
                maxLength={7}
                className="form-control"
                name="chassis"
                value={this.state.vehicle.chassis}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="manufYear">Ano de Fabricação</label>
              <input
                type="number"
                className="form-control"
                name="manufYear"
                value={this.state.vehicle.manufYear}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="modelYear">Ano do Modelo</label>
              <input
                type="number"
                className="form-control"
                name="modelYear"
                value={this.state.vehicle.modelYear}
                onChange={this.handleInputChange}
              />
            </div>

            <button type="submit" hidden />
          </form>

        </Modal.Body>
        <Modal.Footer>
          <a
            className="button"
            onClick={this.handleModalClose}
            onKeyPress={this.handleModalClose}
            role="button"
            tabIndex={0}
          >
            Cancelar
          </a>
          <a
            className="button"
            onClick={this.handleModalAccept}
            onKeyPress={this.handleModalAccept}
            role="button"
            tabIndex={0}
          >
            Confirmar
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalFormVehicleManagement.propTypes = {
  vehicle: PropTypes.shape({
    $key: PropTypes.string,
    plate: PropTypes.string,
    fleet: PropTypes.string,
    model: PropTypes.string,
    brand: PropTypes.string,
    chassis: PropTypes.string,
    manufYear: PropTypes.string,
    modelYear: PropTypes.string,
  }),
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  fleets: PropTypes.object.isRequired,
};

ModalFormVehicleManagement.defaultProps = {
  vehicle: {
    $key: null,
    plate: '',
    fleet: '',
  },
};

export default connect(store => ({
  fleets: store.fleetState.fleets || {},
}))(ModalFormVehicleManagement);



// WEBPACK FOOTER //
// ./src/Vehicle/ModalFormVehicleManagement.js